type Translation = {
  vi: string;
  en: string;
};

const activityStatusRecords: Record<number, Translation> = {
  1: { en: "Swiping card verification", vi: "Thẻ từ" },
  2: { en: "Fingerprint verification", vi: "Vân tay" },
  3: { en: "Face verification", vi: "Khuôn mặt" },
  4: {
    en: "Fingerprint + Swiping card",
    vi: "Vân tay + Thẻ từ",
  },
  5: { en: "Face + Fingerprint", vi: "Khuôn mặt + Vân tay" },
  6: { en: "Face + Swiping card ", vi: "Khuôn mật + Thẻ từ" },
  7: { en: "Swiping card + Password", vi: "Thẻ từ + Mật khẩu" },
  8: { en: "Face + Password", vi: "Khuôn mặt + Mật khẩu" },
  9: { en: "Fingerprint + Password", vi: "Vân tay + Mật khẩu" },
  10: {
    en: "Id and password",
    vi: "Id và mật khẩu",
  },
  11: { en: "Fingerprint + Swiping card + Password", vi: "Vân tay + Thẻ từ + Mật khẩu" },
  12: { en: "Face + Swiping card + Password", vi: "Khuôn mặt + Thẻ từ + Mật khẩu" },
  13: { en: "Face + Fingerprint + Password", vi: "Khuôn mặt + Vân tay + Mật khẩu" },
  14: { en: "Face + Fingerprint + Swiping card", vi: "Khuôn mặt + Vân tay + Thẻ từ" },
  15: { en: "Repeated verification", vi: "Xác thực lặp lại" },
  16: { en: "Expiration date", vi: "Ngày hết hạn" },
  17: { en: "Outside of opening time window", vi: "Thời gian cấm mở cửa" },
  18: { en: "Can't open the door during holidays", vi: "Không thể mở cửa trong ngày lễ" },
  19: { en: "Unregistered user", vi: "Người dùng chưa được đăng ký" },
  20: { en: "Detection lock", vi: "Khóa " },
  21: { en: "The effective number has been used up", vi: "Code 21" },
  22: { en: "Verify when locked. Do not open the door ", vi: "Code 22" },
  23: { en: "Reported lost card ", vi: "Thẻ bị báo cáo mất" },
  24: { en: "Blacklist card", vi: "Thẻ trong danh sách đen" },
  25: {
    en: "Open the door without verification -- the user number is 0 when pressing the fingerprint, and the user number is the card number when swiping the card",
    vi: "Code 25",
  },
  26: {
    en: "No card swiping verification -- when card swiping is disabled in 【access authentication mode】",
    vi: "Code 26",
  },
  27: {
    en: "No fingerprint verification when fingerprint is disabled in [access authentication mode]",
    vi: "Code 27",
  },
  28: { en: "Controller expired", vi: "" },
  29: { en: "Validation passed - expiration date is coming", vi: "" },
  30: { en: "Body temperature abnormal, refused to enter", vi: "Nhiệt độ cơ thể ngoài mức cho phép" },
};

export default activityStatusRecords;
